import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DEPOSIT_SAVED_SUCCESSFULLY} from '../../../../locale/multilingual-strings-constants';
import {MachineUserDepositModel} from '../../model/machine/machine.model';
import {ValidationService} from '../../services/validation.service';
import {NotifierService} from '../../services/notifier.service';
import {PersonalDataService} from '../../../../../personal-data/src/lib/personal-data.service';

@Component({
  selector: 'app-deposit-popup',
  templateUrl: './deposit-popup.component.html',
  styleUrls: ['./deposit-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepositPopupComponent {
  private readonly personalDataId: string;
  public depositForm: FormGroup;

  constructor(
              private ref: DynamicDialogRef,
              private fb: FormBuilder,
              private validationService: ValidationService,
              private notifierService: NotifierService,
              private config: DynamicDialogConfig,
              private cdr: ChangeDetectorRef,
              private personalDataService: PersonalDataService) {

    const deposit = config.data.deposit;
    this.personalDataId = config.data.personalDataId;
    this.depositForm = this.fb.group({
      id: [deposit?.id],
      personalDataId: [deposit?.personalDataId || this.personalDataId],
      company: [deposit?.company, [Validators.required,]],
      amount: [deposit?.amount, [Validators.required,]],
      from: [deposit?.from ? new Date(deposit?.from) : null, [Validators.required,]],
      to: [deposit?.to ? new Date(deposit?.to) : null, [Validators.required,]],
      percent: [deposit?.percent, [Validators.required, this.validationService.validatePercent()]],
    }, {
      validators: this.validationService.validateDateRange('from', 'to'),
    });
  }

  public submit() {
    if (this.depositForm.valid) {
      this.depositForm.disable();
      const body = this.depositForm.value as MachineUserDepositModel;
      const submitRequest$ = this.depositForm.value.id ? this.personalDataService.updateDeposit(body) :
        this.personalDataService.addDeposit(body);

      submitRequest$.subscribe({
        next: response => {
          if (response.succeed) {
            this.notifierService.handleSuccessRequest(DEPOSIT_SAVED_SUCCESSFULLY);
            if (!this.depositForm.value.id) {
              this.depositForm.controls['id'].setValue(response.value);
              this.closeDialog(true);
            } else this.closeDialog(false, true);
          } else {
            this.notifierService.handleErrors(response.errors);
            this.depositForm.enable();
          }
          this.cdr.detectChanges();
        },
        error: err => {
          this.notifierService.handleRequestError(err);
          this.depositForm.enable();
          this.cdr.detectChanges();
        }
      })
    }
  }

  public closeDialog(added: boolean, edited?: boolean) {
    this.ref.close({added, edited, deposit: this.depositForm.value});
  }

}
